module.exports = __webpack_public_path__ + "static/media/rast.68da7a84.jpeg";